/**
 * @deprecated Use 'accepted_payments' and 'ssl_checkout_asset' from
 * repoV2/features/Payments/Payments.constants.ts
 */
export const PAYMENT_MODES_ICONS = {
    visa: {
        alt: "Visa",
        src: "/static/images/payment_modes/visa.png",
    },
    mastercard: {
        alt: "Mastercard",
        src: "/static/images/payment_modes/mastercard.png",
    },
    maestro: {
        alt: "Maestro",
        src: "/static/images/payment_modes/maestro.png",
    },
    amex: {
        alt: "Americal Express",
        src: "/static/images/payment_modes/amex.png",
    },
    rupay: {
        alt: "Rupay",
        src: "/static/images/payment_modes/rupay.png",
    },
};

/**
 * @deprecated Use 'accepted_payments' and 'ssl_checkout_asset' from
 * repoV2/features/Payments/Payments.constants.ts
 */
export const SSL_CHECKOUT_ICON = {
    alt: "SSL Checkout",
    src: "/static/images/payment_modes/ssl-checkout.svg",
};
